import React, { useState } from "react"
import { useTracking } from "react-tracking"
import { Card } from "../../components/card"
import { InputText } from "../../components/input-text/input-text"
import { useFormik } from "formik"
import { formikConfig } from "../../modules/formik/config"
import { CardFooter } from "../../components/card-footer"
import { ConversationBubble } from "../../components/conversation-bubble"
import { getActiveFromValue, InputSelect } from "../../components/input-select/input-select"
import { PrivacyText } from "../../components/privacy"
import Checkbox from "../../components/checkbox"
import { Root } from "../../components/root"

import "./style.scss"

const App = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { trackEvent } = useTracking()
    const formik = useFormik({
        ...formikConfig,
        initialValues: {
            ...formikConfig.initialValues,
            count: "1",
            location: "web",
            source: "demo",
            interests: [],
            mx: false,
        },
    })

    const countConfig = [
        { label: "Just me", value: "1" },
        { label: "2 - 5 people", value: "2-5" },
        { label: "6 - 15 people", value: "6-15" },
        { label: "16 - 50 people", value: "16-50" },
        { label: "51 or more", value: "51+" },
    ]

    const interestsConfig = [
        { label: "Grow marketing & sales", value: "Grow Marketing & Sales" },
        { label: "Email signature consistency", value: "Email Signature Consistency" },
        { label: "Inbox management & tracking", value: "Inbox Management & tracking" },
    ]

    const track = (action: string, label: string) => {
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: action,
            label: label,
        })
    }

    function trackedSubmitForm() {
        setIsLoading(true)
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click button",
            label: "demo",
        })
        formik.submitForm().then((data) => {
            // we check if it is undefined because that means the validation has failed
            if (data !== undefined) {
                trackEvent({
                    event: "genericEvent",
                    category: "submit",
                    action: "submit button",
                    label: "demo",
                })
                window.location.href = "/book-a-demo-with-an-email-expert"
            } else {
                setIsLoading(false)
            }
        })
    }

    const handleChange = (name: string) => {
        track("click checkbox", name.toLowerCase())
        const values = formik.values.interests || []
        const index = values.indexOf(name)
        if (index === -1) {
            values.push(name)
        } else {
            values.splice(index, 1)
        }
        formik.setFieldValue(name, values)
    }

    return (
        <Root id="bad">
            <Card>
                <ConversationBubble
                    header="Hi, I'm Eden. Let's make your emails shine!"
                    para="Our email experts will show you how to transform your everyday emails into a marketing tool 
                    that drives revenue for your business."
                />
                <InputText
                    id="name"
                    className="form-item"
                    label="Full name"
                    error={formik.errors.name as string}
                    placeholder="Your full name"
                    maxLength={100}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
                <InputText
                    id="orgname"
                    className="form-item"
                    label="Business name"
                    error={formik.errors.orgname as string}
                    placeholder="Your business name"
                    maxLength={100}
                    value={formik.values.orgname}
                    onChange={formik.handleChange}
                />
                <InputText
                    id="email"
                    className="form-item"
                    label="Business email"
                    error={formik.errors.email as string}
                    placeholder="Your business email address"
                    maxLength={100}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    autoCapitalize="none"
                />
                <InputText
                    id="workphone"
                    className="form-item"
                    label="Business phone"
                    error={formik.errors.workphone as string}
                    placeholder="Your business phone number"
                    maxLength={30}
                    type={"tel"}
                    value={formik.values.workphone}
                    onChange={formik.handleChange}
                />
                <InputSelect
                    label="How many people are branding their emails?"
                    error={formik.errors.count as string}
                    active={getActiveFromValue(formik.values.count, countConfig)}
                    options={countConfig}
                    id="count"
                    callback={(option) => {
                        formik.setFieldValue("count", option.value, false)
                        formik.setFieldError("count", undefined)
                    }}
                    onFocus={() => track("click select field", "count")}
                    disabled={false}
                />

                <div className="bad-cms">
                    <label className="cms-label">{"What can we help you achieve?"}</label>
                    {interestsConfig.map((tag) => (
                        <Checkbox
                            key={formik.values.interests.management}
                            name={tag.label}
                            checked={formik.values.interests.includes(tag.value)}
                            callback={() => handleChange(tag.value)}
                        >
                            {tag.label}
                        </Checkbox>
                    ))}
                </div>

                <CardFooter className="bad-next" nextAction={trackedSubmitForm} disabled={isLoading}>
                    Book a demo
                </CardFooter>
                <PrivacyText />
            </Card>
        </Root>
    )
}

export default App
